import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AppConstants, LabelConstants } from 'src/app/utilities/app-constants';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { Validators, FormControl } from '@angular/forms';
import { Auth } from 'aws-amplify';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { IValidationResponse } from 'src/app/models/validation-response';
import { CoreServicesService } from '../services/core-services.service';
import { BatonFeature } from 'src/app/models/baton-features';
import { NavDataService } from 'src/app/modules/workshop/services/nav-data.service';
import { FolioHelperService } from 'src/app/utilities/folio-helper.service';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.css']
})
export class AuthenticationComponent implements OnInit, AfterViewInit {
  readonly MY_CONSTANT = LabelConstants;

  username: string;
  password: string;

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email
  ]);

  passwordFormControl = new FormControl('', [
    Validators.required
  ]);
  hidePassword = true;
  token = '';

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private folioHelperService: FolioHelperService,
    private matSnackBar: MatSnackBar,
    private coreService: CoreServicesService,
    private navDataService: NavDataService,
  ) { }

  ngOnInit() {
    this.folioHelperService.setSpinnerVisible(true);
  }

  ngAfterViewInit() {
    // token
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.token = params.get('token');
      if (this.token) {
        this.authenticationService.callValidationServiceQuery(this.token).then(
          (suc) => {
            const loginInfo = JSON.parse(suc['data']['validateToken'].body);
            localStorage.clear();
            localStorage.setItem(AppConstants.PARAM_LOCAL_STORAGE_AUTH_TOKEN, this.token);
            this.folioHelperService.saveDataInLocalStorage(AppConstants.PARAM_LOCAL_STORAGE_AUTH_LOGIN_INFO, loginInfo);
            this.validateCognitoTokenService(suc as IValidationResponse);
            // this.getNavigationList();
            this.folioHelperService.setSpinnerVisible(false);
          }).catch(err => {
            console.log('Error occurred while retrieving details from the validation service: ', err);
            this.folioHelperService.setSpinnerVisible(false);
          });
      } else {
        this.matSnackBar.open('Session expired. Please login again.', null, {
          duration: 3000
        });
        setTimeout(() => {
          window.location.href = environment.urlRedirectToBaton;
        }, 3000);
      }
    });
  }

  getNavigationList() {
    this.folioHelperService.setSpinnerVisible(true);
    const user = JSON.parse(localStorage.getItem(AppConstants.PARAM_LOCAL_STORAGE_AUTH_LOGIN_INFO));
    if (!user) {
      return;
    }

    const payload = {
      query: {
        appId: 9,
        customerId: user.customerId,
        environment: user.backendType ? user.backendType : ''
      },
      headers: {
        cognitotoken: user.sessionId
      }
    };

    this.coreService.lambdaInvoke(environment.lambdaGetFeatures, JSON.stringify(payload)).then(success => {

      const features = JSON.parse(success['Payload'])['records'];

      if (!features) {
        this.folioHelperService.setSpinnerVisible(false);
        return;
      }
      const navList: BatonFeature[] = features.filter((element: BatonFeature) => {
        return element.DATA === '1';
      });
      this.navDataService.navListItems(navList);
      this.folioHelperService.fetchUserName();
      this.folioHelperService.setSpinnerVisible(false);
      this.router.navigate([`/${localStorage.getItem(AppConstants.PARAM_LOCAL_STORAGE_DEFAULT_ROUTE)}`], { replaceUrl: true });

    }).catch(ews => {
      this.folioHelperService.setSpinnerVisible(false);
      this.router.navigate(['/login'], { replaceUrl: true });
    });

  }

  async checkForAuth() {
    let isLoggedIn = false;
    const userAttributes = this.folioHelperService.fetchDataFromLocalStorage('__login_info__');
    if (userAttributes.backendType && userAttributes.backendType === AppConstants.BACKEND_TYPE_BATON) {
      await Auth.currentAuthenticatedUser().then(suc => {
        isLoggedIn = true;
      }).catch(err => {
        console.log('Authenticated user ERROR: ', err);
        isLoggedIn = false;
        this.folioHelperService.setSpinnerVisible(false);
        this.router.navigate(['/login']);
      });
    } else {
      isLoggedIn = true;
    }
    if (isLoggedIn) {
      this.getNavigationList();
    }

  }

  validateCognitoTokenService(responseData: IValidationResponse) {
    const successData = JSON.parse(responseData['data'].validateToken.body);
    const username = successData.userName;
    const userKey = this.folioHelperService.cognitoTokensKey(username, 'LastAuthUser');

    const accToken = successData.sessionId;
    const accessTokenKey = this.folioHelperService.cognitoTokensKey(username, 'accessToken');

    const idToken = successData.idToken;
    const idTokenKey = this.folioHelperService.cognitoTokensKey(username, 'idToken');

    const userData = '';
    const userDataKey = this.folioHelperService.cognitoTokensKey(username, 'userData');

    const refTokenData = successData.refreshToken;
    const refTokenKey = this.folioHelperService.cognitoTokensKey(username, 'refreshToken');

    localStorage.setItem(userKey, username);
    localStorage.setItem(accessTokenKey, accToken);
    localStorage.setItem(idTokenKey, idToken);
    localStorage.setItem(userDataKey, userData);
    localStorage.setItem(refTokenKey, refTokenData);

    this.checkForAuth();

    this.getNavigationList();
    this.folioHelperService.setSpinnerVisible(false);

  }

  authenticateUser() {
    this.username = this.emailFormControl.value;
    this.password = this.passwordFormControl.value;

    if (this.username && this.password) {
      this.authenticationService
        .authenticateUserWithCognito(this.username, this.password)
        .subscribe(success => {
          if (success['code'] === 'failure') {
            alert('Error occured: ' + success['message']);
          }
          if (success['token']) {
            localStorage.setItem(AppConstants.PARAM_LOCAL_STORAGE_AUTH_TOKEN, success['token']);
            this.fetchUserDetails(success['token']);
          }
        });

    } else {
      alert('Check username and/or password');
    }

  }

  fetchUserDetails(token: string) {
    this.authenticationService
      .fetchUserDetails(token)
      .subscribe(
        success => {
          localStorage.setItem(AppConstants.PARAM_LOCAL_STORAGE_AUTH_LOGIN_INFO, JSON.stringify(success));
          this.router.navigate([`/${localStorage.getItem(AppConstants.PARAM_LOCAL_STORAGE_DEFAULT_ROUTE)}`]);
        }
      );
  }

}
